/** @format */

import "../styles/globals.scss"

import { GlobalStyles, theme } from "@ui-library/myslpro"
import React, { useCallback, useEffect, useState } from "react"

import { AuthenticationProvider } from "@aviv-pro-navigation/authentication"
import Hotjar from '@hotjar/browser'
import { Footer } from "@local/commons/dist/components/Footer"
import Layout from "_components/Layout"
import { Loader } from "_components/atoms"
import DatadogRum from "_components/atoms/DatadogRum/DatadogRum"
import ForceSlash from "_components/atoms/ForceSlash/ForceSlash"
import { Toast } from "_components/molecules"
import { Navigation } from "_components/organisms"
import { getMspApiUrl } from "_shared/helpers/unifiedRoutingHelper"
import useUserConsentStore from "_stores/userConsentStore/userConsentStore"
import TrackingConfig from "_tracking/TrackingConfig"
import type { AppProps } from "next/app"
import getConfig from "next/config"
import Head from "next/head"
import Script from "next/script"
import { ThemeProvider } from "styled-components"

const App = ({ Component, pageProps, router }: AppProps) => {
	
    const { hasUserConsented } = useUserConsentStore();

	useEffect(() => {
		if(hasUserConsented && getConfig().publicRuntimeConfig.env == "prod" ){
			Hotjar.init(getConfig().publicRuntimeConfig.HOTJAR_ID, getConfig().publicRuntimeConfig.HOTJAR_VERSION);
		}
	}, [hasUserConsented])

	const [loaderVisible, setLoaderVisible] = useState(true)
	const navigationOnLoad = useCallback(() => {
		setLoaderVisible(false)
	}, [])
	const AnyComponent = Component as any

	const routesWithoutNavigation = ["/quickDispatch","/changeDistributionMode"]
	
	const isNavigationHidden = routesWithoutNavigation.includes(router.pathname)

	
	const context = {
		baseUrl:  getMspApiUrl() + "/api/3.0",
	};
	
	return (
		<div className="root-div">
			<AuthenticationProvider context={context}>
				<TrackingConfig>
					<ThemeProvider theme={theme}>
						<GlobalStyles />

						<Head>
							<title>Hyperfaiseur | MySelogerPro</title>
							<link rel="icon" type="image/x-icon" href="./favicon-msp.png" />
							<meta name="version" content={process.env.NEXT_PUBLIC_VERSION} />
							<ForceSlash />
						</Head>
						<Script
							id="usercentrics-cmp"
							src="https://app.usercentrics.eu/browser-ui/latest/bundle.js"
							data-settings-id="5kYOCoQ5YsSoa9"
							data-tcf-enabled
							strategy="afterInteractive"
						/>
						<Navigation
							onLoad={navigationOnLoad}
							isNavigationHidden={isNavigationHidden}
						/>
						<Toast />
						<Loader visible={loaderVisible} isSticky={false} />
						<Layout hasNavigation={!isNavigationHidden}>
							<AnyComponent {...pageProps} />
						</Layout>
					</ThemeProvider>
					<Footer/>
				</TrackingConfig>
				<DatadogRum />
			</AuthenticationProvider>
		</ div>
	)
}

export default App
